// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/user',
    component: layout,
    redirect: '/user/userAccount',
    hiddenInMenu: true,
    meta: {
      title: '',
      roles: [1]
    },
    children: [
      {
        path: 'userAccount',
        name: 'UserAccount',
        component: () => import('@/views/User/UserAccount.vue'),
        meta: {
          title: '账户管理',
          i18Key: 'router.user.user.userAccount',
          roles: [1]
        }
      },{
        path: 'contactUs',
        name: 'ContactUs',
        component: () => import('@/views/User/ContactUs.vue'),
        meta: {
          title: '联系我们',
          i18Key: 'router.user.user.contactUs',
          roles: [1]
        }
      }
    ]
  }
]
export default routes
